
// SVG Icon: ar-reset-alignment
export default { id: "terriajs-ar-reset-alignment" };
export const id = "terriajs-ar-reset-alignment";
export const name = "ar-reset-alignment";
